export const ERROR_MESSAGE_CLASS =
    "font-normal text-[10px] md:text-xs text-Error_Default";
